import { render, staticRenderFns } from "./ToPlanAudits.vue?vue&type=template&id=649bf733&scoped=true&"
import script from "./ToPlanAudits.vue?vue&type=script&lang=ts&"
export * from "./ToPlanAudits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bf733",
  null
  
)

export default component.exports